import type { SpriteDefinition } from '@/render/spriteBaker';
import { PALETTE } from '@/sprites/palette';

/**
 * A chest, closed and open.
 *
 * Two sprites rather than one tinted differently: "already looted" has to be
 * readable across a dark room at a glance, or a floor becomes a tour of
 * chests you have already emptied.
 */

const CLOSED: string[] = [
  '................',
  '................',
  '................',
  '....mmmmmmmm....',
  '...mMMMMMMMMm...',
  '...mMwwwwwwMm...',
  '...mMMMMMMMMm...',
  '...mmmmmmmmmm...',
  '...mMMMwwMMMMm..',
  '...mMMMwwMMMMm..',
  '...mMMMMMMMMm...',
  '...mMMMMMMMMm...',
  '...mmmmmmmmmm...',
  '................',
  '................',
  '................',
];

/** Lid thrown back and nothing inside but shadow. */
const OPEN: string[] = [
  '................',
  '................',
  '...mmmmmmmmmm...',
  '...mMMMMMMMMm...',
  '...mmmmmmmmmm...',
  '....eeeeeeee....',
  '....eeeeeeee....',
  '...mmmmmmmmmm...',
  '...mMMMMMMMMm...',
  '...mMMMMMMMMm...',
  '...mMMMMMMMMm...',
  '...mmmmmmmmmm...',
  '................',
  '................',
  '................',
  '................',
];

export const CHEST_SPRITES = {
  chestClosed: { name: 'chest-closed', rows: CLOSED, palette: PALETTE },
  chestOpen: { name: 'chest-open', rows: OPEN, palette: PALETTE },
} as const satisfies Record<string, SpriteDefinition>;

export type ChestSpriteKey = keyof typeof CHEST_SPRITES;
